import React, { useEffect } from 'react';

// A small reusable right-side filter panel wrapper used by several admin pages.
// Props:
// - isOpen: boolean
// - onClose: () => void
// - onClear: () => void
// - title: string
// - children: JSX
export default function AdminFilterPanel({ isOpen, onClose, onClear, onApply, title = 'Filters', children, disableOverlayClose = false }) {
  // ensure hooks run on every render (do not place after early return)
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') {
        onClose && onClose();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!isOpen) return null;

  const handleDone = () => {
    if (typeof onApply === 'function') return onApply();
    if (typeof onClose === 'function') return onClose();
  };

  return (
    <>
      {/* overlay - click outside to close */}
      <div
        className="fixed inset-0 bg-black/20 z-[60]"
        onClick={() => {
          if (disableOverlayClose) return;
          onClose && onClose();
        }}
      />

      <div className="fixed right-0 top-0 h-[800px] w-[400px] border border-gray-300 rounded-lg gap-3 mt-2 p-3 bg-gray-50 z-[70] shadow-lg overflow-y-auto">
        <div className="flex items-center justify-between">
          <h1 className="text-semibold text-lg text-black-700">{title}</h1>
          <button onClick={onClose} className="text-muted-foreground">✖</button>
        </div>

        <div className="mt-3">{children}</div>

        <div className="flex justify-end gap-5 mt-5">
          <button
            type="button"
            className="bg-[#DC1F00] hover:bg-[#b51a00] text-white text-sm px-4 py-2 rounded-md transition"
            onClick={handleDone}
          >
            Done
          </button>
          <button
            type="button"
            className="border border-gray-400 text-gray-700 text-sm px-4 py-2 rounded-md hover:bg-gray-100 transition"
            onClick={onClear}
          >
            Clear
          </button>
        </div>
      </div>
    </>
  );
}
